import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { fetchActividades } from "./hooks_cache/useActividadesEconomicas";
import { fetchTerceros } from "./hooks_cache/useTerceros";
import { fetchTiposDte } from "./hooks_cache/useTiposDte";
import { fetchDepartamentos } from "./hooks_cache/useDepartamento";
import { fetchMunicipios } from "./hooks_cache/useMunicipio";
import { fetchComprobantes } from "./hooks_cache/useComprobantes";
import { fetchTipoDocumento } from "./hooks_cache/useTipoDocumento";
import { fetchPagos } from "./hooks_cache/usePagos";
import { fetchInvalidaciones } from "./hooks_cache/useInvalidaciones";
import { fetchTipoContingencia } from "./hooks_cache/useTipoContingencias";
import { fetchEventosContingencia } from "./hooks_cache/useEventoContingencia";

export const usePreloadCache = () => {
  const queryClient = useQueryClient();
  const { empresas, empresaSeleccionada } = useSelector((state) => state.auth);
  const id_empresa = empresaSeleccionada?.id; // ✅ Asegurar que existe un `id_empresa`

  useEffect(() => {
    if (id_empresa) {
      queryClient.prefetchQuery({
        queryKey: ["terceros", id_empresa],
        queryFn: () => fetchTerceros(id_empresa),
      });

      queryClient.prefetchQuery({
        queryKey: ["comprobantes", id_empresa],
        queryFn: () => fetchComprobantes(id_empresa),
        force: true,
      });

      queryClient.prefetchQuery({
        queryKey: ["pagos", id_empresa],
        queryFn: () => fetchPagos(id_empresa),
      });

      queryClient.prefetchQuery({
        queryKey: ["invalidaciones", id_empresa],
        queryFn: () => fetchInvalidaciones(id_empresa),
      });

      queryClient.prefetchQuery({
        queryKey: ["eventos_contingencia", id_empresa],
        queryFn: () => fetchEventosContingencia(id_empresa),
      });
    }
  }, [queryClient, id_empresa]);

  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: ["actividadesEconomicas"],
      queryFn: fetchActividades,
      staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días
      cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días en cache
    });

    queryClient.prefetchQuery({
      queryKey: ["tipoDocumento"],
      queryFn: fetchTipoDocumento,
      staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días
      cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días en cache
    });

    queryClient.prefetchQuery({
      queryKey: ["tiposDte"],
      queryFn: fetchTiposDte,
      staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días
      cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días en cache
    });

    queryClient.prefetchQuery({
      queryKey: ["tipoContingencia"],
      queryFn: fetchTipoContingencia,
      staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días
      cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días en cache
    });

    queryClient.prefetchQuery({
      queryKey: ["departamentos"],
      queryFn: fetchDepartamentos,
      staleTime: 1000 * 60 * 60 * 24, // 24 horas
      cacheTime: 1000 * 60 * 60 * 48, // 48 horas en cache
    });

    queryClient.prefetchQuery({
      queryKey: ["municipios"],
      queryFn: fetchMunicipios,
      staleTime: 1000 * 60 * 60 * 24, // 24 horas
      cacheTime: 1000 * 60 * 60 * 48, // 48 horas en cache
    });
  }, [queryClient]);
};
